import { Navigate, type RouteObject } from 'react-router';

import {
  // PermissionsPage,
  SubscriptionPage,
  MarkingPage,
  SiteIntegrationPage,
  DocumentsPage,
} from '@/pages/settings';
import { PermissionGuard } from '@/app/routers/guards';
import { PermissionsPage } from '@/true-fsd/layout/PermissionsPage';
import { HistoryTreeWrite } from '@/app/routers';

export const settings = {
  path: 'settings',
  children: [
    {
      path: 'permissions',
      element: (
        <PermissionGuard permissionKey="admin">
          <HistoryTreeWrite>
            <PermissionsPage />
          </HistoryTreeWrite>
        </PermissionGuard>
      ),
    },
    {
      path: 'marking',
      element: (
        <HistoryTreeWrite>
          <MarkingPage />
        </HistoryTreeWrite>
      ),
    },
    {
      path: 'documents',
      element: (
        <HistoryTreeWrite>
          <DocumentsPage />
        </HistoryTreeWrite>
      ),
    },
    {
      path: 'subscription',
      element: (
        <HistoryTreeWrite>
          <SubscriptionPage />
        </HistoryTreeWrite>
      ),
    },
    {
      path: 'site-integration',
      element: (
        <HistoryTreeWrite>
          <SiteIntegrationPage />
        </HistoryTreeWrite>
      ),
    },
    {
      index: true,
      element: <Navigate to="marking" />,
    },
    {
      path: '*',
      element: <Navigate to=".." />,
    },
  ],
} satisfies RouteObject;
